/**
 * API de cotação USD/BRL - Frankfurter (gratuita, sem chave)
 * https://www.frankfurter.dev/
 */

const FRANKFURTER_URL = 'https://api.frankfurter.dev/v1/latest?base=USD&symbols=BRL';

interface FrankfurterResponse {
  amount: number;
  base: string;
  date: string;
  rates: { BRL: number };
}

let cachedRate: number | null = null;
let cacheTimestamp: number = 0;
const CACHE_TTL_MS = 60 * 60 * 1000; // 1 hora

export async function fetchUsdToBrlRate(): Promise<{ rate: number; date: string } | null> {
  if (cachedRate !== null && Date.now() - cacheTimestamp < CACHE_TTL_MS) {
    return { rate: cachedRate, date: new Date(cacheTimestamp).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }) };
  }

  try {
    const response = await fetch(FRANKFURTER_URL);
    if (!response.ok) throw new Error('Falha ao buscar cotação');
    const data: FrankfurterResponse = await response.json();
    const rate = data.rates?.BRL;
    if (typeof rate !== 'number' || rate <= 0) throw new Error('Cotação inválida');
    cachedRate = rate;
    cacheTimestamp = Date.now();
    const dateFormatted = data.date
      ? new Date(data.date + 'T12:00:00').toLocaleDateString('pt-BR')
      : new Date().toLocaleDateString('pt-BR');
    return { rate, date: dateFormatted };
  } catch (error) {
    console.warn('Erro ao buscar cotação USD/BRL:', error);
    return null;
  }
}

export function convertUsdToBrl(usdAmount: number, rate: number): number {
  return usdAmount * rate;
}
